export const COLLECT_SESSION_USER_DATA_INTENT = "collect-session-user-data";
export const RESTORE_SUPPORT_CHAT_IDENTITY_INTENT = "restore-support-chat-identity";
